import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    border: 1px solid white;
    width: 5rem;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`
const TestButton = props => {

    return(
        <Container onClick={() => {console.log('Test')}}>
            Test
        </Container>
    )
}

export default TestButton